<email-layout>
  <ng-container logo>
    <email-recruitee-logo />
  </ng-container>

  <ng-container header>
    <email-message-header [header]="data.header" [imageUrl]="data.avatar_url" [separator]="false" />
    <email-text [contents]="data.p1_html" className="web-rt-contains-link" />
  </ng-container>

  <ng-container body>
    <ng-container *mailgunIf="data.message_html">
      <email-margin [height]="28" />
      <div class="admin-message-box">
        <email-text [contents]="data.message_html" />
      </div>
    </ng-container>
    <email-margin [height]="28" />
    <email-button [href]="data.button_link" [label]="data.button_text" theme="primary" />
  </ng-container>

  <ng-container footer>
    <email-text [contents]="data.footer" color="light" presetName="inline" size="small" />&nbsp;
    <email-link
      [label]="data.support_email"
      [href]="data.support_email"
      [prefix]="'mailto:'"
      [textOpts]="{ size: 'small', color: 'light' }"
      textPreset="inline"
    />
  </ng-container>
</email-layout>
